import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=5ec96a1a&scoped=true&"
import script from "./Appbar.vue?vue&type=script&lang=js&"
export * from "./Appbar.vue?vue&type=script&lang=js&"
import style0 from "./Appbar.vue?vue&type=style&index=0&id=5ec96a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec96a1a",
  null
  
)

export default component.exports